import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);


const resizeObserverErr = window.console.error;
window.console.error = (...args) => {
  if (args[0]?.includes?.("ResizeObserver loop")) return;
  resizeObserverErr(...args);
};

window.addEventListener("error", (e) => {
  if (e.message?.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
  }
});


reportWebVitals();